var p = (o, e, r) => new Promise((g, s) => {
  var u = (n) => {
    try {
      i(r.next(n));
    } catch (t) {
      s(t);
    }
  }, a = (n) => {
    try {
      i(r.throw(n));
    } catch (t) {
      s(t);
    }
  }, i = (n) => n.done ? g(n.value) : Promise.resolve(n.value).then(u, a);
  i((r = r.apply(o, e)).next());
});
import { selfAxios as c } from "@oppein/op-utils";
function l(o) {
  return p(this, null, function* () {
    const {
      data: e
    } = yield c.post(
      "/production-order/engineering/salesEngineeringSignApply/query",
      o
    );
    return e == null ? void 0 : e.data;
  });
}
export {
  l as postQuery
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/salesEngineeringSignApply/query/post.js
// module id = 1831
// module chunks = 67